import toast from "react-hot-toast";

/**
 * What every screen does when the API answers 402 (the plan's billing date
 * has passed).
 *
 * A lapsed seller can still view their pages; only creating, paying and
 * requesting are refused. Those refusals used to send the seller to the plans
 * page without a word, so it looked like a random jump. Now they are told why,
 * once (the fixed id stops three failing calls from stacking three toasts).
 */
export const PLAN_ENDED_MESSAGE = "Your plan has ended. Renew it to continue.";

export function onPlanEnded(navigate) {
  toast.error(PLAN_ENDED_MESSAGE, { id: "plan-ended" });
  navigate("/subscriptionPlans");
}

/** True when the stored user's billing date has passed. */
export function isPlanEnded(user) {
  const due = user?.next_billing_date;
  if (!due) return false;
  const when = new Date(String(due).replace(" ", "T"));
  return !Number.isNaN(when.getTime()) && when <= new Date();
}
